import pluralize from 'pluralize';
import React from 'react';

import { pollDaysRemaining } from '@utils/backend-api/polls';

interface PollResultProps {
  totalVotes: number;
  expiresAt?: string | null;
  pollClosed?: boolean;
  canVote?: boolean;
  userVoted?: boolean;
}

export default function PollResult({
  totalVotes,
  expiresAt,
  pollClosed,
  canVote,
  userVoted,
}: PollResultProps) {
  if (totalVotes === 0 && canVote && !pollClosed) {
    return (
      <div>
        <span className="font-suisse-screen text-byline-sm text-black">Be first to vote</span>
      </div>
    );
  }

  const daysLeft = pollDaysRemaining(expiresAt);
  return (
    <div>
      <span className="font-suisse-screen text-byline-sm text-grayscale-gray">
        {pluralize('vote', totalVotes, true)}
      </span>
      <span className="text-grayscale-grey px-12 font-suisse-screen text-byline-sm">&middot;</span>
      {!pollClosed && expiresAt && daysLeft > 0 && (
        <span className="font-suisse-screen text-byline-sm text-black">
          {pluralize('day', daysLeft, true)} left to vote
        </span>
      )}
      {userVoted && (
        <span className="font-suisse-screen text-byline-sm text-black">Thanks for voting!</span>
      )}
    </div>
  );
}
